import { useCallback } from 'react';

import { logException } from '@atlassian/conversation-assistant-instrumentation/services/sentry';
import { ROVO_EXTENSION_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/clients/rovo-extension-client';
import {
	BrowserContextCommand,
	type BrowserContextCommandResult,
} from '@atlassian/rovo-content-bridge-api-commands/commands/browser-context-command';

import { useBridgeSendCommand } from '../context/useBridgeSendCommand';

/** For actions related to the environment of the conversation assistant */
export const useEnvironmentAction = (): {
	requestBrowserContent: () => Promise<BrowserContextCommandResult | undefined>;
} => {
	const { sendCommand } = useBridgeSendCommand();

	const requestBrowserContent = useCallback(async (): Promise<
		BrowserContextCommandResult | undefined
	> => {
		try {
			const invocation = await sendCommand(BrowserContextCommand, {
				receiverId: ROVO_EXTENSION_CLIENT_ID,
				buffer: false,
			});
			const result = await invocation.result();
			return result;
		} catch (error) {
			logException({
				exception: error,
				name: 'SendBridgeCommandError',
			});
			return undefined;
		}
	}, [sendCommand]);

	return {
		requestBrowserContent,
	};
};
